var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content finance-code-mapping" },
        [
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { "min-height": "100%" },
              attrs: {
                "left-style": { flex: "none", "max-width": "220px" },
                "right-style": { overflow: "hidden" }
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "min-width": "180px",
                      width: "100%",
                      height: "100%",
                      padding: "0px"
                    }
                  },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "min-height": "500px",
                        "padding-left": "0px"
                      },
                      attrs: {
                        "show-side-bar": false,
                        "grid-options": _vm.leftGrid.gridOptions,
                        "row-data": _vm.leftGrid.rowData,
                        "column-defs": _vm.leftGrid.columnDefs
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.leftGrid.gridApi = params.api
                          _vm.leftGrid.gridApi.setFocusedCell(0, "chineseName")
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("template", { slot: "right" }, [
                _c(
                  "div",
                  {
                    staticClass: "section operations",
                    staticStyle: {
                      flex: "1",
                      overflow: "hidden",
                      display: "flex",
                      "flex-direction": "column",
                      height: "100%"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "filters",
                        staticStyle: { "padding-left": "5px" }
                      },
                      [
                        _vm.isEdit
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.saveHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.cancelHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                                )
                              ],
                              1
                            )
                          : _c(
                              "span",
                              [
                                _vm.txtFilterVisible
                                  ? _c("el-input", {
                                      staticStyle: {
                                        width: "200px",
                                        margin: "0 5px 0 5px"
                                      },
                                      model: {
                                        value: _vm.txtFilter,
                                        callback: function($$v) {
                                          _vm.txtFilter = $$v
                                        },
                                        expression: "txtFilter"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.cbNewMappingVisible
                                  ? _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { margin: "0 10px 0 5px" },
                                        model: {
                                          value: _vm.cbNewMapping,
                                          callback: function($$v) {
                                            _vm.cbNewMapping = $$v
                                          },
                                          expression: "cbNewMapping"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_DisplayUnCodedRecordsOnly"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.queryCodeMapping }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.addHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled: !_vm.cellSelected
                                    },
                                    on: { click: _vm.editHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      disabled: !_vm.cellSelected
                                    },
                                    on: { click: _vm.removeHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                                ),
                                _vm.txtFilterVisible
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.downloadExcelTitleHandler
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_TemplateDownload"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.txtFilterVisible
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          margin: "0 5px"
                                        },
                                        attrs: {
                                          action: _vm.URL.sys.saveExcelFileUrl,
                                          headers: {
                                            sessionId:
                                              _vm.$store.getters.userInfo
                                                .sessionId
                                          },
                                          data: {
                                            code: _vm.code,
                                            officeId: this.$store.getters
                                              .currentOfficeId
                                          },
                                          "show-file-list": false,
                                          accept: ".xls, .xlsx",
                                          "on-success": _vm.onImportSucceeded,
                                          "on-error": _vm.handleError,
                                          "before-upload":
                                            _vm.handleBeforeUpload
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          { attrs: { type: "primary" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_ImportExcel"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "section grid-wrapper" },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            "min-height": "500px"
                          },
                          attrs: {
                            "show-side-bar": false,
                            "grid-params": _vm.gridParams,
                            "grid-options": _vm.gridOptions,
                            "column-defs": _vm.columnDefs,
                            "row-data": _vm.rowData
                          },
                          on: {
                            "update:gridParams": function($event) {
                              _vm.gridParams = $event
                            },
                            "update:grid-params": function($event) {
                              _vm.gridParams = $event
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pagination-wrapper" },
                      [
                        _c("cargo-pagination", {
                          attrs: {
                            total: _vm.pageConditions.total,
                            page: _vm.pageConditions.pageNum,
                            limit: _vm.pageConditions.pageSize
                          },
                          on: {
                            "update:page": function($event) {
                              return _vm.$set(
                                _vm.pageConditions,
                                "pageNum",
                                $event
                              )
                            },
                            "update:limit": function($event) {
                              return _vm.$set(
                                _vm.pageConditions,
                                "pageSize",
                                $event
                              )
                            },
                            pagination: _vm.queryCodeMapping
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowDialogForm,
            title: _vm.dialogTitle,
            "inline-message": "",
            width: "405px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowDialogForm = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "mappingForm",
              attrs: {
                model: _vm.mappingForm,
                "label-width": "120px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Name") } },
                [
                  _vm.code === _vm.SystemConstants.MAPPING_CHARGE_ITEM.code
                    ? _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.mappingForm.sourceValue,
                            callback: function($$v) {
                              _vm.$set(_vm.mappingForm, "sourceValue", $$v)
                            },
                            expression: "mappingForm.sourceValue"
                          }
                        },
                        _vm._l(_vm.lobTypeList, function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    : _vm.code === _vm.SystemConstants.MAPPING_ACCOUNT_CODE.code
                    ? _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.mappingForm.sourceValue,
                            callback: function($$v) {
                              _vm.$set(_vm.mappingForm, "sourceValue", $$v)
                            },
                            expression: "mappingForm.sourceValue"
                          }
                        },
                        _vm._l(_vm.officeList, function(item) {
                          return _c("el-option", {
                            key: item.officeId,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.officeId
                            }
                          })
                        }),
                        1
                      )
                    : _vm.code ===
                      _vm.SystemConstants.MAPPING_RECEIPT_OR_PAYMENT.code
                    ? _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.mappingForm.sourceValue,
                            callback: function($$v) {
                              _vm.$set(_vm.mappingForm, "sourceValue", $$v)
                            },
                            expression: "mappingForm.sourceValue"
                          }
                        },
                        _vm._l(_vm.payTypeList, function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    : _c("el-input", {
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.mappingForm.sourceValue,
                          callback: function($$v) {
                            _vm.$set(_vm.mappingForm, "sourceValue", $$v)
                          },
                          expression: "mappingForm.sourceValue"
                        }
                      })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_TaxRevenueShortName") }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.mappingForm.targetValue,
                      callback: function($$v) {
                        _vm.$set(_vm.mappingForm, "targetValue", $$v)
                      },
                      expression: "mappingForm.targetValue"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini " },
                  on: {
                    click: function($event) {
                      _vm.isShowDialogForm = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.invoiceTitle.visible
        ? _c("invoice-title", {
            attrs: { visible: _vm.invoiceTitle.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoiceTitle, "visible", $event)
              },
              enter: _vm.enterHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }